import { Component, OnInit, ViewChild } from '@angular/core';
import { WfTableComponent } from '../../../common/table-sort/wf-table.component';
import { GenericModalService } from '../../../services/generic-modal.service';
import { ExtractionService } from '../../../services/configuration/extraction.service';
import { ExtractionLayoutModalComponent } from './extraction-layout-modal/extraction-layout-modal.component';

@Component({
  selector: 'app-data-extraction-layout',
  templateUrl: './data-extraction-layout.component.html',
  styleUrls: ['./data-extraction-layout.component.css']
})
export class DataExtractionLayoutComponent implements OnInit {

  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;
  layoutList: any[];
  pleaseWait = false;
  successMessage = '';
  errorMessage = '';
  modalComponent: any = ExtractionLayoutModalComponent;

  constructor(
    private extractionService: ExtractionService,
    private modalService: GenericModalService
  ) { }

  ngOnInit() {
    this.loadList();
  }

  loadList() {
    this.pleaseWait = true;
    this.extractionService.getFileLayoutsForDataExtraction()
      .subscribe(res => {
        this.pleaseWait = false;
        setTimeout(() => { this.layoutList = res; }, 1);
      }, error1 => {
        this.pleaseWait = false;
        this.errorMessage = error1;
      });
  }

  onDeleteLayout(layout) {
    this.errorMessage = '';
    let alert: any;
    alert = this.modalService.showConfirmModal('Aviso de exclusão', `Confirma a exclusão do layout <b>${layout.name}</b>?`);
    alert.then( resp => {
      if (resp.value) {
        this.extractionService.deleteDataExtractionFileLayout(layout)
          .subscribe( () => {
              this.successMessage = `Layout ${layout.name} excluído com sucesso.`;
              this.ngOnInit();
              setTimeout(() => {
                this.successMessage = '';
              }, 2000);
            },
            error1 => {
              this.errorMessage = error1;
            });
      }
    });
  }

  onAddNew() {
    const newLayout = {};
    const result$ = this.modalService.showObjModal(this.modalComponent, 'Cadastrar Layout', newLayout);
    result$.asObservable()
      .subscribe(
        itemHasBeenSaved => {
          if (itemHasBeenSaved) { this.ngOnInit(); }
        });
  }

  onEditLayout(layout) {
    const result$ = this.modalService.showObjModal(this.modalComponent, 'Editar Layout', layout);
    result$.asObservable()
      .subscribe(
        itemHasBeenSaved => {
          if (itemHasBeenSaved) { this.ngOnInit(); }
        }
      );
  }

}
